module.exports = __webpack_public_path__ + "static/media/docnew.af526162.svg";